import React, { useState, useEffect } from 'react';
import { Box, Container, Skeleton, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

const HomeHero = (props) => {
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(true);
  const [image, setImage] = useState('');

  useEffect(() => {
    (async () => {
      const response = await fetch('/static/home/eyerenafrontimage6.jpg');
      const blob = await response.blob();
      setImage(URL.createObjectURL(blob));
      setIsLoading(false);
    })();
  }, [theme.palette.mode]);

  return (
    <Box
      sx={{
        backgroundColor: 'background.paper',
        pt: 6
      }}
      {...props}
    >
      <Container
        maxWidth="md"
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          px: {
            md: '130px !important'
          }
        }}
      >
        <Typography
          align="center"
          color="textPrimary"
          variant="h1"
        >
          Die neue Plattform
        </Typography>
        <Typography
          align="center"
          color="textSecondary"
          variant="h4"
          sx={{ py: 2 }}
        >
          für digitales Visual- und Kognitionstraining (ViCo)
        </Typography>
      </Container>
      <Container
        maxWidth="false"
        sx={{
          width: '100%',
          px: {
            md: 0
          }
        }}
      >
        <Box
          sx={{
            position: 'relative',
            pt: !isLoading && '52.13%'
          }}
        >
          {isLoading
            ? (
              <Skeleton
                sx={{
                  borderRadius: 1,
                  width: '100%',
                  pt: '52.13%'
                }}
                variant="rectangular"
              />
            )
            : (
              <img
                alt="eyerena start logo"
                src={image}
                style={{
                  maxWidth: '100%',
                  backgroundSize: 'cover',
                  borderRadius: 0,
                  zIndex: 20,
                  position: 'absolute',
                  bottom: 50,
                  left: 0,
                  right: 0,
                  top: 50
                }}
              />
            )}
        </Box>
      </Container>
    </Box>
  );
};

export default HomeHero;
